import { Breadcrumbs, Link, Typography } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useNavigate } from 'react-router-dom';

const ProjectBreadcrumbs = ({ item, name }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs aria-label="breadcrumbs" separator={<ChevronRightRoundedIcon />} sx={{ pl: 0, pt: 0 }}>
      <Link underline="hover" color="inherit" component="button" onClick={() => navigate('/projects')}>
        Projects
      </Link>
      {name && (
        <Link underline="hover" color="inherit" component="button" onClick={() => navigate(`/projects/${item.pk}/${item.id}`)}>
          {item.name}
        </Link>
      )}
      <Typography color="text.primary">{name ? name : item.name}</Typography>
    </Breadcrumbs>
  );
};

export default ProjectBreadcrumbs;
